// src/components/ShopVideos.js
import React from 'react';

export default function ShopVideos({ setCurrentPage = () => {} }) {
  const shopVideos = [
    { id: 1,  src: '/videos/shop_tour1.mp4',  },
    { id: 2,  src: '/videos/shop_tour2.mp4',  },
    { id: 3,  src: '/videos/shop_tour3.mp4',  },
   
    { id: 5,  src: '/videos/shop_tour5.mp4',  },
    { id: 6,  src: '/videos/shop_tour6.mp4',  },
    { id: 7,  src: '/videos/shop_tour7.mp4',  },
    { id: 8,  src: '/videos/shop_tour8.mp4',  },
  ];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', // Forces page to full height, pinning footer perfectly
      backgroundColor: '#f8fafc',
      fontFamily: '"Inter", sans-serif' 
    }}>
      
      {/* Main Content Container */}
      <div style={{ flex: '1', maxWidth: '1200px', width: '100%', margin: '0 auto', padding: '60px 20px', boxSizing: 'border-box' }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0f172a', marginBottom: '10px', textAlign: 'center' }}>
          Our Shop's videos
        </h2>
        <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '40px', fontSize: '1.1rem' }}>
          Take a virtual walkthrough of our live inventory bays.
        </p>

        <div style={{ 
          backgroundColor: '#ffffff', 
          borderRadius: '16px', 
          border: '1px solid #e2e8f0', 
          boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)', 
          padding: '30px'
        }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '24px' 
          }}>
            {shopVideos.map((video) => (
              <div key={video.id} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', padding: '12px' }}>
                <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#000', height: '180px' }}>
                  <video src={video.src} controls muted style={{ width: '100%', height: '100%', objectFit: 'cover' }} preload="metadata">
                    Your browser does not support the video playback feature.
                  </video>
                </div>
                <div style={{ marginTop: '12px' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '1rem', color: '#0f172a', fontWeight: '700' }}>{video.title}</h4>
                  <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', lineHeight: '1.4' }}>{video.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Professional Corporate Footer */}
      <footer style={{ 
        backgroundColor: '#0f172a', 
        color: '#94a3b8', 
        padding: '40px 20px', 
        marginTop: 'auto', 
        borderTop: '1px solid #1e293b'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '30px' }}>
          <div>
            <h5 style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: '700', margin: '0 0 10px 0' }}>Shabaaz Trading Co.</h5>
            <p style={{ fontSize: '0.9rem', maxWidth: '320px', lineHeight: '1.5', margin: 0 }}>
              Global distributors of premium commercial maritime parts, heavy deck machinery, and raw components.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '60px', flexWrap: 'wrap' }}>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', margin: '0 0 12px 0', fontSize: '0.95rem' }}>Navigation</h6>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '0.9rem', lineHeight: '2.2' }}>
                <li><button onClick={() => setCurrentPage('home')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Home</button></li>
                <li><button onClick={() => setCurrentPage('products')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Products</button></li>
                <li><button onClick={() => setCurrentPage('about')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>About Us</button></li>
                <li><button onClick={() => setCurrentPage('certificates')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Certificates</button></li>
                <li><button onClick={() => setCurrentPage('videos')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Shop Videos</button></li>
                <li><button onClick={() => setCurrentPage('contact')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Contact Us</button></li>
              </ul>
            </div>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', margin: '0 0 12px 0', fontSize: '0.95rem' }}>Supply Desk</h6>
              <p style={{ fontSize: '0.9rem', margin: '0 0 6px 0' }}>Support: shabaaztradingco04@gmail.com</p>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>WhatsApp: +91 90162 35501</p>
            </div>
          </div>
        </div>
        <div style={{ maxWidth: '1200px', margin: '30px auto 0 auto', paddingTop: '20px', borderTop: '1px solid #1e293b', fontSize: '0.85rem', textAlign: 'center' }}>
          &copy; {new Date().getFullYear()} Shabaaz Trading Co. Marine Distribution Network. All rights reserved.
        </div>
      </footer>

    </div>
  );
}